import ReactCountryFlag from 'react-country-flag'
import { countryList } from './country-list'

export const Flags = ReactCountryFlag

export const useCountryFilterOptions = () =>
  countryList.map(country => ({
    label: country.name,
    value: country.code,
  }))
